import React, { useState } from 'react';
import { Grid, Chip, Divider } from '@mui/material';

// MD Components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';
import MDBadge from 'components/MDBadge';

// Icons
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import CancelIcon from '@mui/icons-material/Cancel';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import ArchiveIcon from '@mui/icons-material/Archive';

// Search Context
import { useSearch } from 'layouts/production/Pages/SearchProvider';

export default function FilterPanel() {
    const { filters, updateFilters } = useSearch();

    // Filter options
    const approvalFilters = [
        {
            key: 'approved',
            label: 'Onaylı',
            value: 1,
            color: 'success',
            icon: <CheckCircleIcon sx={{ fontSize: '0.875rem' }} />,
        },
        {
            key: 'pending',
            label: 'Onayda',
            value: 0,
            color: 'warning',
            icon: <HourglassEmptyIcon sx={{ fontSize: '0.875rem' }} />,
        },
        {
            key: 'rejected',
            label: 'Ret',
            value: -1,
            color: 'error',
            icon: <CancelIcon sx={{ fontSize: '0.875rem' }} />,
        },
    ];

    const quickFilters = [
        {
            key: 'hideDepoSiparisi',
            label: 'Depo Siparişi Gizle',
            icon: <VisibilityOffIcon sx={{ fontSize: '0.875rem' }} />,
        },
        { key: 'hideKapali', label: 'Kapalı Gizle', icon: <ArchiveIcon sx={{ fontSize: '0.875rem' }} /> },
    ];

    const handleApprovalFilter = (value) => {
        const currentApproval = filters?.onayDurum || [];
        const newApproval = currentApproval.includes(value)
            ? currentApproval.filter((v) => v !== value)
            : [...currentApproval, value];

        updateFilters({ ...filters, onayDurum: newApproval });
    };

    const handleQuickFilter = (key) => {
        updateFilters({ ...filters, [key]: !filters?.[key] });
    };

    const clearAllFilters = () => {
        updateFilters({});
    };

    const hasActiveFilters =
        filters && (filters.onayDurum?.length > 0 || filters.hideDepoSiparisi || filters.hideKapali);

    return (
        <MDBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            px={2}
            py={1}
            mb={2}
            sx={{
                backgroundColor: 'grey.50',
                borderRadius: 1,
                border: '1px solid',
                borderColor: 'grey.200',
            }}
        >
            {/* Left side - Filters */}
            <MDBox display="flex" flexWrap="wrap" alignItems="center" gap={1}>
                <FilterListIcon sx={{ fontSize: '1rem', color: 'text.secondary' }} />
                {hasActiveFilters && (
                    <MDBadge
                        badgeContent={
                            (filters?.onayDurum?.length || 0) +
                            (filters?.hideDepoSiparisi ? 1 : 0) +
                            (filters?.hideKapali ? 1 : 0)
                        }
                        color="info"
                        size="xs"
                    />
                )}

                {/* Approval Status Filters */}
                <MDTypography variant="caption" color="text.secondary" mr={0.5}>
                    Onay:
                </MDTypography>
                {approvalFilters.map((filter) => (
                    <Chip
                        key={filter.key}
                        icon={filter.icon}
                        label={filter.label}
                        variant={filters?.onayDurum?.includes(filter.value) ? 'filled' : 'outlined'}
                        color={filters?.onayDurum?.includes(filter.value) ? filter.color : 'default'}
                        size="small"
                        onClick={() => handleApprovalFilter(filter.value)}
                        sx={{
                            fontSize: '0.75rem',
                            height: '26px',
                            cursor: 'pointer',
                        }}
                    />
                ))}

                {/* Divider */}
                <MDBox sx={{ width: '1px', height: '16px', backgroundColor: 'grey.300', mx: 0.5 }} />

                {/* Quick Filters */}
                <MDTypography variant="caption" color="text.secondary" mr={0.5}>
                    Hızlı:
                </MDTypography>
                {quickFilters.map((filter) => (
                    <Chip
                        key={filter.key}
                        icon={filter.icon}
                        label={filter.label}
                        variant={filters?.[filter.key] ? 'filled' : 'outlined'}
                        color={filters?.[filter.key] ? 'primary' : 'default'}
                        size="small"
                        onClick={() => handleQuickFilter(filter.key)}
                        sx={{
                            fontSize: '0.75rem',
                            height: '26px',
                            cursor: 'pointer',
                        }}
                    />
                ))}
            </MDBox>

            {/* Right side - Clear button */}
            {hasActiveFilters && (
                <MDButton
                    variant="text"
                    color="error"
                    size="small"
                    startIcon={<ClearIcon sx={{ fontSize: '0.75rem' }} />}
                    onClick={clearAllFilters}
                    sx={{
                        fontSize: '0.75rem',
                        padding: '4px 8px',
                        textTransform: 'none',
                        minWidth: 'auto',
                    }}
                >
                    Temizle
                </MDButton>
            )}
        </MDBox>
    );
}
